import { useCallback, useState } from 'react';

/**
 * Un interruptor que el navegador recuerda.
 *
 * Para preferencias de PRESENTACION de quien mira -la barra lateral plegada,
 * un panel de resumen minimizado-: cosas que no son datos del sistema y que
 * fastidian si hay que volver a ponerlas en cada visita.
 *
 * Todos los accesos van en `try`. `localStorage` no es solo "puede estar
 * vacio": en una ventana privada, con las cookies de sitio bloqueadas o
 * durante una captura de miniatura, LEERLO LANZA. Sin proteccion, una
 * preferencia de adorno tumbaria la pantalla entera.
 *
 * Lo que se guarda no sale de ese navegador: no viaja al servidor ni a los
 * demas dispositivos de la misma persona, y por eso aqui no va nada que
 * alguien pueda necesitar recuperar en otro sitio.
 */
export function usePersistedToggle(key: string, inicial = false): readonly [boolean, () => void] {
  const [activo, setActivo] = useState(() => leer(key, inicial));

  const alternar = useCallback(() => {
    setActivo((anterior) => {
      const siguiente = !anterior;
      try {
        localStorage.setItem(key, String(siguiente));
      } catch {
        // La preferencia no persiste; la sesion en curso funciona igual.
      }
      return siguiente;
    });
  }, [key]);

  return [activo, alternar];
}

function leer(key: string, inicial: boolean): boolean {
  try {
    const guardado = localStorage.getItem(key);
    return guardado === null ? inicial : guardado === 'true';
  } catch {
    return inicial;
  }
}
